import React from "react";
import SocialStrip from "./SocialStrip";
import { Facebook, Instagram, Linkedin, Twitter, YouTube } from "../icons";
import { NavQuery } from "~/gql/graphql";
import type { SerializeFrom } from "@remix-run/node";
import DesktopNavContentful from "./DesktopNavContentful";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { getNavigationComponentFromContentfulRichTextEntry } from "~/contentful";
import MobileNavContentful from "./MobileNavContentful";

export type NavLinkContentful = {
  title: string | null | undefined;
  descriptionHeader: string;
  descriptionText: React.ReactNode;
  headersCollection: {
    url: string;
    label: string;
    linkCollection: {
      label: string;
      url: string;
    }[];
  }[];
};

export default function NavContentful({
  data,
}: {
  data: SerializeFrom<NavQuery>;
}) {
  const primaryNavigationItems =
    data?.navigationCollection?.items[0]?.itemsCollection?.items;
  const links: NavLinkContentful[] =
    primaryNavigationItems?.map((item) => {
      return {
        title: item?.title || "",
        descriptionHeader: item?.descriptionHeader || "",
        descriptionText: item?.descriptionText?.json
          ? documentToReactComponents(
              item.descriptionText.json,
              getNavigationComponentFromContentfulRichTextEntry,
            )
          : null,
        headersCollection:
          item?.headersCollection?.items.map((header) => {
            return {
              url: header?.url || "",
              label: header?.label || "",
              linkCollection:
                header?.linkCollection?.items.map((link) => {
                  return {
                    label: link?.label || "",
                    url: link?.url || "",
                  };
                }) || [],
            };
          }) || [],
      };
    }) || [];

  const socials = [
    {
      name: "X",
      href: "https://twitter.com/InstituteGC",
      icon: Twitter,
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/company/tony-blair-institute-for-global-change/",
      icon: Linkedin,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/institutegc/",
      icon: Instagram,
    },
    {
      name: "Facebook",
      href: "https://www.facebook.com/instituteglobal/",
      icon: Facebook,
    },
    {
      name: "YouTube",
      href: "https://www.youtube.com/TonyBlairInstituteforGlobalChange/",
      icon: YouTube,
    },
  ];

  return (
    <>
      <SocialStrip links={socials} />
      <DesktopNavContentful links={links} />
      <MobileNavContentful links={links} />
    </>
  );
}
